<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-alert", { attrs: { variant: "primary", show: "" } }, [
        _c("div", { staticClass: "alert-body" }, [
          _c("div", { staticClass: "alert-msg" }, [
            _c(
              "div",
              [
                _c("feather-icon", {
                  attrs: { icon: "AlertCircleIcon", size: "20" },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "alert-desc" }, [
              _vm._v(" " + _vm._s(_vm.$t("payment.note")) + " "),
            ]),
          ]),
        ]),
      ]),
      _c("validation-observer", {
        ref: "registerForm",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var invalid = ref.invalid
              return [
                _c(
                  "b-form",
                  {
                    staticClass: "auth-register-form mt-2",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.addPayment($event)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "pay-scroll" },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex custom-label" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "bv-no-focus-ring col-form-label pt-0",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("payment.payment-method")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s("*") + " ")]
                                        ),
                                      ]
                                    ),
                                    _c("validation-provider", {
                                      attrs: {
                                        name: _vm.$t("payment.payment-method"),
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("SelectPaymentMethod", {
                                                  attrs: {
                                                    multiple: false,
                                                    isEditFlag: _vm.isEditFlag,
                                                  },
                                                  model: {
                                                    value: _vm.paymentMethod,
                                                    callback: function ($$v) {
                                                      _vm.paymentMethod = $$v
                                                    },
                                                    expression: "paymentMethod",
                                                  },
                                                }),
                                                _c("Errors", {
                                                  attrs: { error: errors[0] },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._l(_vm.paymentFields, function (field, index) {
                              return _c(
                                "b-col",
                                { key: index, attrs: { cols: "12" } },
                                [
                                  field.id !== "qrcode.doc"
                                    ? _c(
                                        "b-form-group",
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex custom-label",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "bv-no-focus-ring col-form-label pt-0",
                                                },
                                                [_vm._v(_vm._s(field.name))]
                                              ),
                                              field.rules &&
                                              field.rules.required
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [_vm._v(_vm._s("*") + " ")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c("validation-provider", {
                                            attrs: {
                                              name: field.name,
                                              rules: field.rules,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          type: field.type,
                                                          name: field.name,
                                                          disabled:
                                                            field.id ===
                                                            "accountName",
                                                        },
                                                        model: {
                                                          value: field.value,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              field,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "field.value",
                                                        },
                                                      }),
                                                      _c("Errors", {
                                                        attrs: {
                                                          error: errors[0],
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            _vm.qrcodeSupport
                              ? _c(
                                  "b-col",
                                  {
                                    staticClass: "mobile-100",
                                    attrs: { cols: "4" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "upload-txt mb-0" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "d-flex custom-label",
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "bv-no-focus-ring col-form-label pt-0",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("payment.QR-code")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm.qrIsRequired
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s("*") + " ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-uplooad error-outer",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "img-upload" },
                                          [
                                            _vm.imageSrc
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c("b-img", {
                                                      staticStyle: {
                                                        "max-width": "100%",
                                                      },
                                                      attrs: {
                                                        src: _vm.imageSrc,
                                                        alt: _vm.$t(
                                                          "payment.QrImage"
                                                        ),
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm.accountQrcodeUrl
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c("b-img", {
                                                      staticStyle: {
                                                        "max-width": "100%",
                                                      },
                                                      attrs: {
                                                        src: _vm.accountQrcodeUrl,
                                                        alt: _vm.$t(
                                                          "payment.QrImage"
                                                        ),
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _c("div", [_c("Upload")], 1),
                                            _c("b-form-file", {
                                              staticClass:
                                                "custom-file-input display-block curserPointer",
                                              attrs: { accept: "image/*" },
                                              on: {
                                                input: _vm.handleFileSelected,
                                              },
                                              model: {
                                                value: _vm.documentQr,
                                                callback: function ($$v) {
                                                  _vm.documentQr = $$v
                                                },
                                                expression: "documentQr",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("Errors", {
                                          attrs: { error: _vm.qrImgError },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "submit-button" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "min-120-btn",
                            attrs: {
                              variant: "primary",
                              disabled:
                                invalid ||
                                (_vm.qrcodeSupport &&
                                  _vm.qrIsRequired &&
                                  !_vm.documentQr &&
                                  !_vm.accountQrcodeUrl) ||
                                _vm.isLoading,
                              type: "submit",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("payment.Confirm")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/Imps.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import validations from '@validations';
import vue_select from 'vue-select';
import assets_rashi_coin_upload_svg from '@/assets/rashi-coin/upload.svg';
import * as veevalidate from 'vee-validate';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import layouts_components_SelectPaymentMethod_vue from '@/layouts/components/SelectPaymentMethod.vue';
import libs_api_api from '@/libs/api/api';
import * as vuex from 'vuex';
import assets_rashi_coin_upload_icon_svg from '@/assets/rashi-coin/upload_icon.svg';
import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












export default ({
  render,
  staticRenderFns,
  components: {
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"],
    BAlert: bootstrapvue["BAlert"],
    vSelect: vue_select,
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BFormInput: bootstrapvue["BFormInput"],
    BFormGroup: bootstrapvue["BFormGroup"],
    Upload: assets_rashi_coin_upload_svg,
    BFormFile: bootstrapvue["BFormFile"],
    BForm: bootstrapvue["BForm"],
    ValidationProvider: veevalidate["ValidationProvider"],
    ValidationObserver: veevalidate["ValidationObserver"],
    SelectPaymentMethod: layouts_components_SelectPaymentMethod_vue,
    Reupload: assets_rashi_coin_upload_icon_svg,
    BImg: bootstrapvue["BImg"],
    Errors: layouts_components_Errors_vue
  },
  data() {
    return {
      paymentMethod: "",
      accountName: "",
      branchCode: "",
      bankName: "",
      accountId: "",
      EditPayment: false,
      documentQr: null,
      imageSrc: null,
      option: [],
      isLoading: false,
      qrcodeSupport: false,
      qrImgError: null,
      paymentFields: [],
      paymentMethodTextTemp: "",
      qrIsRequired: false,
      min: validations["min"],
      max: validations["max"],
      required: validations["required"]
    };
  },
  props: {
    closePaymentPop: {
      type: Function,
      default: () => {}
    },
    showData: {
      type: Array,
      default: () => []
    },
    paymentMethodText: {
      type: String,
      default: ""
    },
    isEditFlag: {
      type: Boolean,
      default: false
    },
    id: {
      // type: String,
      default: ""
    },
    accountQrcodeUrl: {
      default: ""
    }
  },
  computed: {
    ...vuex.mapState("user", ["refData", "user"])
  },
  mounted() {
    if (this.isEditFlag && this.showData && this.showData.length && this.paymentMethodText) {
      this.paymentMethodTextTemp = this.paymentMethodText;
      this.paymentMethod = this.paymentMethodText;
      const foundObject = this.refData.countryData.paymentMethods.find(obj => obj.id === this.paymentMethodText);
      this.qrcodeSupport = foundObject.qrcodeSupport;
      // this.paymentFields = this.showData;
      this.paymentFields = this.showData.map(field => {
        if (field.id === "qrcode.doc") {
          this.qrIsRequired = field.isRequired;
        }
        return {
          ...field
        };
      }) || [];
    } else if (this.refData && this.refData.countryData && this.refData.countryData.paymentMethods && this.refData.countryData.paymentMethods.length && this.refData.countryData.paymentMethods[0].id) {
      this.paymentMethodTextTemp = this.refData.countryData.paymentMethods[0].id;
      this.paymentMethod = this.refData.countryData.paymentMethods[0].id;
      this.mapFields(this.refData.countryData.paymentMethods[0].fields);
      this.qrcodeSupport = this.refData.countryData.paymentMethods[0].qrcodeSupport;
    }
  },
  watch: {
    refData(newVal) {
      if (!this.isEditFlag && this.refData && this.refData.countryData && this.refData.countryData.paymentMethods && this.refData.countryData.paymentMethods.length && this.refData.countryData.paymentMethods[0].id) {
        this.paymentMethod = this.refData.countryData.paymentMethods[0].id;
        this.qrcodeSupport = this.refData.countryData.paymentMethods[0].qrcodeSupport;
        this.mapFields(this.refData.countryData.paymentMethods[0].fields);
      }
    },
    paymentMethod(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        if (this.paymentMethodTextTemp != newVal && this.refData && this.refData.countryData && this.refData.countryData.paymentMethods && this.refData.countryData.paymentMethods.length) {
          this.paymentMethodTextTemp = newVal;
          const foundObject = this.refData.countryData.paymentMethods.find(obj => obj.id === newVal);
          this.qrcodeSupport = foundObject ? foundObject.qrcodeSupport : null;
          this.mapFields(foundObject.fields);
        }
      }
    },
    isEditFlag(newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.showPropsData();
    },
    showData(newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.showPropsData();
    },
    paymentMethodText(newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.showPropsData();
    }
  },
  methods: {
    showPropsData() {
      if (this.isEditFlag && this.showData && this.showData.length && this.paymentMethodText) {
        this.paymentMethod = this.paymentMethodText;
        // this.paymentFields = this.showData;
        this.qrcodeSupport = foundObject.qrcodeSupport;
        // this.paymentFields = this.showData;
        this.paymentFields = this.showData.map(field => {
          if (field.id === "qrcode.doc") {
            this.qrIsRequired = field.isRequired;
          }
          return {
            ...field
          };
        }) || [];
      }
    },
    mapFields(fields) {
      this.qrIsRequired = false;
      this.paymentFields = fields.map(field => {
        if (field.id === "qrcode.doc") {
          this.qrIsRequired = field.isRequired;
        }
        const rules = {};
        if (field.isRequired) {
          rules.required = true;
        }
        if (field.maxSize) {
          rules.max = parseInt(field.maxSize);
        }
        if (field.minSize) {
          rules.min = parseInt(field.minSize);
        }
        if (field.regex) {
          rules.regex = new RegExp(field.regex);
        }
        if (field.type && field.type === "string") {
          field.type = "text";
        }
        if (field.id === "accountName") {
          return {
            ...field,
            value: this.user.name,
            rules
          };
        } else {
          return {
            ...field,
            value: null,
            rules
          };
        }
      }) || [];
    },
    handleFileSelected() {
      // Convert the selected File to a data URL
      if (this.documentQr) {
        const reader = new FileReader();
        reader.onload = event => {
          this.imageSrc = event.target.result;
        };
        reader.readAsDataURL(this.documentQr);
      }
    },
    validateImg() {
      if (this.qrIsRequired && this.qrcodeSupport && !this.imageSrc) {
        if (!this.imageSrc) {
          this.qrImgError = this.$t("Errors.qrImageRequired");
        } else {
          this.qrImgError = "";
        }
        return false;
      } else {
        this.qrImgError = "";
      }
      return true;
    },
    async addPayment() {
      try {
        this.isLoading = true;
        if (!this.validateImg()) {
          return;
        }
        const formData = new FormData();
        this.id && formData.append("id", this.id);
        formData.append("paymentMethod", this.paymentMethod);
        for (let i = 0; i < this.paymentFields.length; i++) {
          if (this.paymentFields[i].id !== "qrcode.doc") {
            formData.append(this.paymentFields[i].id, this.paymentFields[i].value);
          } else {
            this.documentQr && formData.append("qrcode.doc", this.documentQr);
          }
        }
        const res = await new libs_api_api().api({
          method: "POST",
          url: `p2p/payment/save`
        }, formData, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus == "SUCCESS") {
          let msg = "";
          if (this.id) {
            msg = this.$t("feedbback.PaymentMethodUpdatedSuccessfully");
          } else {
            msg = this.$t("feedbback.PaymentMethodSaveSuccessfully");
          }
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: msg,
              icon: "EditIcon",
              variant: "success"
            }
          });
          this.closePaymentPop(true);
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/Imps.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
.pay-scroll {
  max-height: 50vh;
  overflow-y: auto;
}[dir=ltr] .pay-scroll {
  padding-left: 15px;
  padding-right: 15px;
  margin-left: -15px;
  margin-right: -15px;
}[dir=rtl] .pay-scroll {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: -15px;
  margin-left: -15px;
}
.v-select {
  position: relative;
  font-family: inherit;
}
.v-select,
.v-select * {
  box-sizing: border-box;
}

/* KeyFrames */
@-webkit-keyframes vSelectSpinner-ltr {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
@-webkit-keyframes vSelectSpinner-rtl {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(-360deg);
}
}
@keyframes vSelectSpinner-ltr {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
@keyframes vSelectSpinner-rtl {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(-360deg);
}
}
/* Dropdown Default Transition */
.vs__fade-enter-active,
.vs__fade-leave-active {
  pointer-events: none;
  transition: opacity 0.15s cubic-bezier(1, 0.5, 0.8, 1);
}
.vs__fade-enter,
.vs__fade-leave-to {
  opacity: 0;
}

/** Component States */
/*
 * Disabled
 *
 * When the component is disabled, all interaction
 * should be prevented. Here we modify the bg color,
 * and change the cursor displayed on the interactive
 * components.
 */
[dir] .vs--disabled .vs__dropdown-toggle, [dir] .vs--disabled .vs__clear, [dir] .vs--disabled .vs__search, [dir] .vs--disabled .vs__selected, [dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: #f8f8f8;
}

/*
 *  RTL - Right to Left Support
 *
 *  Because we're using a flexbox layout, the `dir="rtl"`
 *  HTML attribute does most of the work for us by
 *  rearranging the child elements visually.
 */
.v-select[dir=rtl] .vs__actions {
  padding: 0 3px 0 6px;
}
.v-select[dir=rtl] .vs__clear {
  margin-left: 6px;
  margin-right: 0;
}
.v-select[dir=rtl] .vs__deselect {
  margin-left: 0;
  margin-right: 2px;
}
.v-select[dir=rtl] .vs__dropdown-menu {
  text-align: right;
}

/**
    Dropdown Toggle

    The dropdown toggle is the primary wrapper of the component. It
    has two direct descendants: .vs__selected-options, and .vs__actions.

    .vs__selected-options holds the .vs__selected's as well as the
    main search input.

    .vs__actions holds the clear button and dropdown toggle.
 */
.vs__dropdown-toggle {
  appearance: none;
  display: flex;
  white-space: normal;
}
[dir] .vs__dropdown-toggle {
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}
.vs__selected-options {
  display: flex;
  flex-basis: 100%;
  flex-grow: 1;
  flex-wrap: wrap;
  position: relative;
}
[dir] .vs__selected-options {
  padding: 0 2px;
}
.vs__actions {
  display: flex;
  align-items: center;
}
[dir=ltr] .vs__actions {
  padding: 4px 6px 0 3px;
}
[dir=rtl] .vs__actions {
  padding: 4px 3px 0 6px;
}

/* Dropdown Toggle States */
[dir] .vs--searchable .vs__dropdown-toggle {
  cursor: text;
}
[dir] .vs--unsearchable .vs__dropdown-toggle {
  cursor: pointer;
}
[dir] .vs--open .vs__dropdown-toggle {
  border-bottom-color: transparent;
}
[dir=ltr] .vs--open .vs__dropdown-toggle {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=rtl] .vs--open .vs__dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.vs__open-indicator {
  fill: rgba(60, 60, 60, 0.5);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
}
[dir] .vs__open-indicator {
  transform: scale(1);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
[dir=ltr] .vs--open .vs__open-indicator {
  transform: rotate(180deg) scale(1);
}
[dir=rtl] .vs--open .vs__open-indicator {
  transform: rotate(-180deg) scale(1);
}
.vs--loading .vs__open-indicator {
  opacity: 0;
}

/* Clear Button */
.vs__clear {
  fill: rgba(60, 60, 60, 0.5);
}
[dir] .vs__clear {
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
[dir=ltr] .vs__clear {
  margin-right: 8px;
}
[dir=rtl] .vs__clear {
  margin-left: 8px;
}

/* Dropdown Menu */
.vs__dropdown-menu {
  display: block;
  box-sizing: border-box;
  position: absolute;
  top: calc(100% - 1px);
  z-index: 1000;
  width: 100%;
  max-height: 350px;
  min-width: 160px;
  overflow-y: auto;
  list-style: none;
}
[dir] .vs__dropdown-menu {
  padding: 5px 0;
  margin: 0;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  border: 1px solid #d8d6de;
  border-top-style: none;
  border-radius: 0 0 0.357rem 0.357rem;
  background: #fff;
}
[dir=ltr] .vs__dropdown-menu {
  left: 0;
  text-align: left;
}
[dir=rtl] .vs__dropdown-menu {
  right: 0;
  text-align: right;
}
[dir] .vs__no-options {
  text-align: center;
}

/* List Items */
.vs__dropdown-option {
  line-height: 1.42857143;
  /* Normalize line height */
  display: block;
  color: #333;
  /* Overrides most CSS frameworks */
  white-space: nowrap;
}
[dir] .vs__dropdown-option {
  padding: 3px 20px;
  clear: both;
}
[dir] .vs__dropdown-option:hover {
  cursor: pointer;
}
.vs__dropdown-option--highlight {
  color: #8dc540 !important;
}
[dir] .vs__dropdown-option--highlight {
  background: rgba(141, 197, 64, 0.12);
}
.vs__dropdown-option--disabled {
  color: rgba(60, 60, 60, 0.5);
}
[dir] .vs__dropdown-option--disabled {
  background: inherit;
}
[dir] .vs__dropdown-option--disabled:hover {
  cursor: inherit;
}

/* Selected Tags */
.vs__selected {
  display: flex;
  align-items: center;
  color: #333;
  line-height: 1.8;
  z-index: 0;
}
[dir] .vs__selected {
  background-color: #8dc540;
  border: 0 solid rgba(60, 60, 60, 0.26);
  border-radius: 0.357rem;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
}
.vs__deselect {
  display: inline-flex;
  appearance: none;
  fill: rgba(60, 60, 60, 0.5);
}
[dir] .vs__deselect {
  padding: 0;
  border: 0;
  cursor: pointer;
  background: none;
  text-shadow: 0 1px 0 #fff;
}
[dir=ltr] .vs__deselect {
  margin-left: 4px;
}
[dir=rtl] .vs__deselect {
  margin-right: 4px;
}

/* States */
[dir] .vs--single .vs__selected {
  background-color: transparent;
  border-color: transparent;
}
.vs--single.vs--open .vs__selected {
  position: absolute;
  opacity: 0.4;
}
.vs--single.vs--searching .vs__selected {
  display: none;
}

/* Search Input */
/**
 * Super weird bug... If this declaration is grouped
 * below, the cancel button will still appear in chrome.
 * If it's up here on it's own, it'll hide it.
 */
.vs__search::-webkit-search-cancel-button {
  display: none;
}
.vs__search::-webkit-search-decoration,
.vs__search::-webkit-search-results-button,
.vs__search::-webkit-search-results-decoration,
.vs__search::-ms-clear {
  display: none;
}
.vs__search,
.vs__search:focus {
  appearance: none;
  line-height: 1.8;
  font-size: 1em;
  outline: none;
  width: 0;
  max-width: 100%;
  flex-grow: 1;
  z-index: 1;
}
[dir] .vs__search, [dir] .vs__search:focus {
  border: 1px solid transparent;
  margin: 4px 0 0 0;
  padding: 0 7px;
  background: none;
  box-shadow: none;
}
[dir=ltr] .vs__search, [dir=ltr] .vs__search:focus {
  border-left: none;
}
[dir=rtl] .vs__search, [dir=rtl] .vs__search:focus {
  border-right: none;
}
.vs__search::placeholder {
  color: #6e6b7b;
}

/**
    States
 */
.vs--unsearchable .vs__search {
  opacity: 1;
}
[dir] .vs--unsearchable:not(.vs--disabled) .vs__search:hover {
  cursor: pointer;
}
.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search {
  opacity: 0.2;
}

/* Loading Spinner */
.vs__spinner {
  align-self: center;
  opacity: 0;
  font-size: 5px;
  text-indent: -9999em;
  overflow: hidden;
  transition: opacity 0.1s;
}
[dir] .vs__spinner {
  border-top: 0.9em solid rgba(100, 100, 100, 0.1);
  border-bottom: 0.9em solid rgba(100, 100, 100, 0.1);
  transform: translateZ(0);
}
[dir=ltr] .vs__spinner {
  border-right: 0.9em solid rgba(100, 100, 100, 0.1);
  border-left: 0.9em solid rgba(60, 60, 60, 0.45);
  animation:  vSelectSpinner-ltr 1.1s infinite linear;
}
[dir=rtl] .vs__spinner {
  border-left: 0.9em solid rgba(100, 100, 100, 0.1);
  border-right: 0.9em solid rgba(60, 60, 60, 0.45);
  animation:  vSelectSpinner-rtl 1.1s infinite linear;
}
.vs__spinner,
.vs__spinner:after {
  width: 5em;
  height: 5em;
}
[dir] .vs__spinner, [dir] .vs__spinner:after {
  border-radius: 50%;
}

/* Loading Spinner States */
.vs--loading .vs__spinner {
  opacity: 1;
}
.vs__open-indicator {
  fill: none;
}
[dir] .vs__open-indicator {
  margin-top: 0.15rem;
}
.vs__dropdown-toggle {
  transition: all 0.25s ease-in-out;
}
[dir] .vs__dropdown-toggle {
  padding: 0.59px 0 4px 0;
}
[dir=ltr] .vs--single .vs__dropdown-toggle {
  padding-left: 6px;
}
[dir=rtl] .vs--single .vs__dropdown-toggle {
  padding-right: 6px;
}
.vs__dropdown-option--disabled {
  opacity: 0.5;
}
[dir] .vs__dropdown-option--disabled.vs__dropdown-option--selected {
  background: #8dc540 !important;
}
.vs__dropdown-option {
  color: #6e6b7b;
}
[dir] .vs__dropdown-option, [dir] .vs__no-options {
  padding: 7px 20px;
}
.vs__dropdown-option--selected {
  background-color: #8dc540;
  color: #fff;
  position: relative;
}
.vs__dropdown-option--selected::after {
  content: "";
  height: 1.1rem;
  width: 1.1rem;
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 1.1rem;
}
[dir=rtl] .vs__dropdown-option--selected::after {
  left: 20px;
  right: unset;
}
.vs__dropdown-option--selected.vs__dropdown-option--highlight {
  color: #fff !important;
  background-color: #8dc540 !important;
}
.vs__clear svg {
  color: #6e6b7b;
}
.vs__selected {
  color: #fff;
}
.v-select.vs--single .vs__selected {
  color: #6e6b7b;
  transition: transform 0.2s ease;
}
[dir] .v-select.vs--single .vs__selected {
  margin-top: 5px;
}
[dir=ltr] .v-select.vs--single .vs__selected input {
  padding-left: 0;
}
[dir=rtl] .v-select.vs--single .vs__selected input {
  padding-right: 0;
}
[dir=ltr] .vs--single.vs--open .vs__selected {
  transform: translateX(5px);
}
[dir=rtl] .vs--single.vs--open .vs__selected {
  transform: translateX(-5px);
}
.vs__selected .vs__deselect {
  color: inherit;
}
.v-select:not(.vs--single) .vs__selected {
  font-size: 0.9rem;
}
[dir] .v-select:not(.vs--single) .vs__selected {
  border-radius: 3px;
  padding: 0 0.6em;
}
[dir=ltr] .v-select:not(.vs--single) .vs__selected {
  margin: 5px 2px 2px 5px;
}
[dir=rtl] .v-select:not(.vs--single) .vs__selected {
  margin: 5px 5px 2px 2px;
}
.v-select:not(.vs--single) .vs__deselect svg {
  vertical-align: text-top;
}
[dir] .v-select:not(.vs--single) .vs__deselect svg {
  transform: scale(0.8);
}
.vs__dropdown-menu {
  top: calc(100% + 1rem);
}
[dir] .vs__dropdown-menu {
  border: none;
  border-radius: 6px;
  padding: 0;
}
[dir] .vs--open .vs__dropdown-toggle {
  border-color: #8dc540;
  border-bottom-color: #8dc540;
  box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
}
[dir=ltr] .vs--open .vs__dropdown-toggle {
  border-bottom-left-radius: 0.357rem;
  border-bottom-right-radius: 0.357rem;
}
[dir=rtl] .vs--open .vs__dropdown-toggle {
  border-bottom-right-radius: 0.357rem;
  border-bottom-left-radius: 0.357rem;
}
.select-size-lg .vs__selected {
  font-size: 1rem !important;
}
[dir] .select-size-lg.vs--single.vs--open .vs__selected {
  margin-top: 6px;
}
.select-size-lg .vs__dropdown-toggle,
.select-size-lg .vs__selected {
  font-size: 1.25rem;
}
[dir] .select-size-lg .vs__dropdown-toggle {
  padding: 5px;
}
[dir] .select-size-lg .vs__dropdown-toggle input {
  margin-top: 0;
}
.select-size-lg .vs__deselect svg {
  vertical-align: middle !important;
}
[dir] .select-size-lg .vs__deselect svg {
  transform: scale(1) !important;
}
[dir] .select-size-sm .vs__dropdown-toggle {
  padding-bottom: 0;
  padding: 1px;
}
[dir] .select-size-sm.vs--single .vs__dropdown-toggle {
  padding: 2px;
}
.select-size-sm .vs__dropdown-toggle,
.select-size-sm .vs__selected {
  font-size: 0.9rem;
}
[dir] .select-size-sm .vs__actions {
  padding-top: 2px;
  padding-bottom: 2px;
}
.select-size-sm .vs__deselect svg {
  vertical-align: middle !important;
}
[dir] .select-size-sm .vs__search {
  margin-top: 0;
}
.select-size-sm.v-select .vs__selected {
  font-size: 0.75rem;
}
[dir] .select-size-sm.v-select .vs__selected {
  padding: 0 0.3rem;
}
[dir] .select-size-sm.v-select:not(.vs--single) .vs__selected {
  margin: 4px 5px;
}
[dir] .select-size-sm.v-select.vs--single .vs__selected {
  margin-top: 1px;
}
[dir] .select-size-sm.vs--single.vs--open .vs__selected {
  margin-top: 4px;
}
.dark-layout .vs__dropdown-toggle {
  color: #b4b7bd;
}
[dir] .dark-layout .vs__dropdown-toggle {
  background: #283046;
  border-color: #404656;
}
.dark-layout .vs__selected-options input {
  color: #b4b7bd;
}
.dark-layout .vs__selected-options input::placeholder {
  color: #676d7d;
}
.dark-layout .vs__actions svg {
  fill: #404656;
}
[dir] .dark-layout .vs__dropdown-menu {
  background: #283046;
}
.dark-layout .vs__dropdown-menu li {
  color: #b4b7bd;
}
.dark-layout .v-select:not(.vs--single) .vs__selected {
  color: #8dc540;
}
[dir] .dark-layout .v-select:not(.vs--single) .vs__selected {
  background-color: rgba(141, 197, 64, 0.12);
}
.dark-layout .v-select.vs--single .vs__selected {
  color: #b4b7bd !important;
}
.dark-layout .vs--disabled .vs__dropdown-toggle,
.dark-layout .vs--disabled .vs__clear,
.dark-layout .vs--disabled .vs__search,
.dark-layout .vs--disabled .vs__selected,
.dark-layout .vs--disabled .vs__open-indicator {
  opacity: 0.5;
}
[dir] .dark-layout .vs--disabled .vs__dropdown-toggle, [dir] .dark-layout .vs--disabled .vs__clear, [dir] .dark-layout .vs--disabled .vs__search, [dir] .dark-layout .vs--disabled .vs__selected, [dir] .dark-layout .vs--disabled .vs__open-indicator {
  background-color: #283046;
}
</style>
